/**
 * @generated SignedSource<<1e9562df589189a8cbf24146ffa3c29e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceContainerSecondary_viewer$data = {
  readonly isWordpressArticlesEnabled: boolean | null;
  readonly itemRead: ReadonlyArray<{
    readonly internalBuyLinks?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_links">;
    } | null> | null;
    readonly serviceId?: string | null;
    readonly storyTellingModule?: {
      readonly tabs: ReadonlyArray<{
        readonly supplementaryEditorial: {
          readonly articles: ReadonlyArray<{
            readonly __typename: "WordpressArticleType";
          }> | null;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedEditorialArticles_refactor_item" | "PdpSharedSellerItemsCarousel_item" | "PdpSharedVisuallySimilarItemsCarouselLazy_item" | "SharedRespLinksBlock_item">;
  } | null> | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplacePersonalizedCarouselLazy_user" | "PdpSharedFeaturedRelatedItemsCarouselLazy_user" | "PdpSharedSellerItemsCarousel_user" | "PdpSharedVisuallySimilarItemsCarouselLazy_user" | "PdpSharedYMALItemsCarousel_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplacePersonalizedCarouselLazy_viewer" | "PdpSharedFeaturedRelatedItemsCarouselLazy_viewer" | "PdpSharedSellerItemsCarousel_viewer" | "PdpSharedVisuallySimilarItemsCarouselLazy_viewer" | "PdpSharedYMALItemsCarousel_viewer" | "SharedRespLinksBlock_viewer">;
  readonly " $fragmentType": "PdpRespMarketplaceContainerSecondary_viewer";
};
export type PdpRespMarketplaceContainerSecondary_viewer$key = {
  readonly " $data"?: PdpRespMarketplaceContainerSecondary_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceContainerSecondary_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceContainerSecondary_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedYMALItemsCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerItemsCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedVisuallySimilarItemsCarouselLazy_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespMarketplacePersonalizedCarouselLazy_viewer"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFeaturedRelatedItemsCarouselLazy_viewer"
        }
      ]
    },
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "WP_EDITORIAL"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedYMALItemsCarousel_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedSellerItemsCarousel_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedVisuallySimilarItemsCarouselLazy_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespMarketplacePersonalizedCarouselLazy_user"
            },
            {
              "condition": "afterDisplay",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedFeaturedRelatedItemsCarouselLazy_user"
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "InternalBuyLinkType",
              "kind": "LinkedField",
              "name": "internalBuyLinks",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SharedRespLinksBlock_links"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "shortTitles",
                  "value": true
                }
              ],
              "concreteType": "StoryTellingModule",
              "kind": "LinkedField",
              "name": "storyTellingModule",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoryTellingTab",
                  "kind": "LinkedField",
                  "name": "tabs",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WordpressArticlesType",
                      "kind": "LinkedField",
                      "name": "supplementaryEditorial",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WordpressArticleType",
                          "kind": "LinkedField",
                          "name": "articles",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "storyTellingModule(shortTitles:true)"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedRespLinksBlock_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedSellerItemsCarousel_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedEditorialArticles_refactor_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedVisuallySimilarItemsCarouselLazy_item"
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0153d2864d195f85e386df581445b058";

export default node;
